// PWA service worker registration.
//
// This used to be an inline <script> in index.html, but the server now sends a
// Content-Security-Policy with `script-src 'self'`, which blocks inline scripts.
// Registering from the bundle keeps the PWA working under that policy.
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.log("ServiceWorker registration failed: ", err);
    });
  });
}
